import { createContext } from 'react';

export interface AuthContextValue {
  user: Record<string, unknown> | null;
  setUser: (user: Record<string, unknown> | null) => void;
  signInWithGoogleFunc: (code: string) => Promise<any>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
